exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg[data-v-597ecdd4] {\n  display: flex;\n  margin-bottom: 8px;\n}\n.error-msg .error-icn[data-v-597ecdd4] {\n  width: 20px;\n  height: 20px;\n  background: tomato;\n  color: #fff;\n  display: block;\n  border-radius: 3px;\n  text-align: center;\n  line-height: 20px;\n  flex: none;\n  margin-right: 15px;\n}\n.error-msg .error-txt[data-v-597ecdd4] {\n  color: tomato;\n}\n.fade-enter-active[data-v-597ecdd4],\n.fade-leave-active[data-v-597ecdd4] {\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-597ecdd4],\n.fade-leave-to[data-v-597ecdd4] {\n  opacity: 0;\n}", ""]);

// exports
